import type { VisitOptions } from "@inertiajs/core"

/**
 * Seitenwechsel blenden per View Transition über, wie fizzy mit Turbo.
 * Filter, Polling und Teil-Reloads bleiben auf derselben Seite und würden
 * sonst bei jedem Tastendruck oder Tick flackern – sie laufen ohne. Formulare
 * (POST, PUT, PATCH, DELETE) ebenso: scheitert die Validierung, landet man auf
 * derselben Seite, und die Fehler sollen erscheinen, ohne dass alles blinkt.
 * Ein eigener Callback am Aufruf bleibt erhalten; abschalten lässt sich die
 * Transition dort nicht, weil `<Link>` immer `viewTransition: false` mitschickt.
 */
export function visitOptions(_href: string, options: VisitOptions) {
  if (options.viewTransition) return {}

  return { viewTransition: changesPage(options) }
}

function changesPage(options: VisitOptions) {
  return (
    (options.method ?? "get") === "get" &&
    !options.preserveState &&
    !options.async &&
    !options.only?.length &&
    !options.except?.length
  )
}
